import { Fragment } from 'react';
import NumberFormat from 'react-number-format';
import {
  DataStatus,
  Table,
  THead,
  Tr,
  Td,
  Th,
  ThFixed,
  TBody,
} from 'components';

import { RowItemSF, calcSubtotalSF } from './RowItemSF';

export const TableSF = ({
  showTotalPrice = false,
  readOnly = false,
  title = '',
  data = [],
}) => {
  const reduceSubTotal = parseFloat(
    data.reduce(
      (subTotal, values) => Math.round(subTotal + calcSubtotalSF(values)),
      0
    )
  );

  return (
    <Fragment>
      <div className="mt-2" style={{ fontSize: '.9rem' }}>
        {title}
      </div>
      <div className="table-responsive">
        <Table>
          <THead className="bg-light">
            <Tr>
              <ThFixed className="text-nowrap">No.</ThFixed>
              <Th width={300}>Uraian Pekerjaan</Th>
              <ThFixed className="text-nowrap">Qty.</ThFixed>
              <ThFixed width={150}>Satuan</ThFixed>
              <ThFixed className="text-nowrap">Unit Price (Rp)</ThFixed>
              <ThFixed className="text-nowrap">Konst.</ThFixed>
              <ThFixed className="text-nowrap">Sub Total Price (Rp)</ThFixed>
              {readOnly ? null : <ThFixed>Aksi</ThFixed>}
            </Tr>
          </THead>

          <TBody>
            {data?.length ? (
              data?.map((val, index) => (
                <RowItemSF key={index} index={index} data={val} />
              ))
            ) : (
              <Tr>
                <Td colSpan={9}>
                  <DataStatus text="Tidak ada data" />
                </Td>
              </Tr>
            )}

            {data?.length && showTotalPrice ? (
              <Tr>
                <Td textRight colSpan={6}>
                  Total Price
                </Td>
                <Td textRight>
                  <NumberFormat
                    value={reduceSubTotal}
                    displayType="text"
                    prefix="Rp"
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                  />
                </Td>
              </Tr>
            ) : null}
          </TBody>
        </Table>
      </div>
    </Fragment>
  );
};
